import React from 'react';
import { FormControl, FormLabel, OutlinedInput } from '@mui/material';

const DialogContentComponent: React.FC<{
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({ value, onChange }) => {
  return (
    <FormControl fullWidth>
      <FormLabel>Subscribe</FormLabel>
      <OutlinedInput
        fullWidth
        placeholder="Enter your email"
        value={value}
        onChange={onChange}
      />
    </FormControl>
  );
};

export default DialogContentComponent;
